var SUPERSTRONG = (!SUPERSTRONG ? {} : SUPERSTRONG);

(function($){

	SUPERSTRONG.dispatcher = !SUPERSTRONG.dispatcher ? $({}) : SUPERSTRONG.dispatcher;
	SUPERSTRONG.YtVideo = function (){

		var instance = {};
		instance.wrapPlayer = function (){

				
			$('iframe.youtube').wrap('<div class="player-container"></div>')


		}

		return instance;


	}()

		$(document).ready(function (){

			//console.log (SUPERSTRONG.YtVideo)
			SUPERSTRONG.YtVideo.wrapPlayer();
		})



} )(jQuery)